// SlideDrawer.tsx
import React, {memo, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {Button} from "antd";

function PopupGate () {
    const { param } = useParams() as { param: string };
    useEffect(() => {
        const url:string =    `../${param}`;
        let options = "toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no,width=500, height=1200, top=50,left=1200";
        // 팝업 창을 열고 현재 페이지를 닫음
        const popupWindow = window.open(url, 'CallDocuWizPopUp', options);

        // 팝업 창이 차단되었을 경우에 대한 예외 처리
        if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
            alert('팝업 창이 차단되었습니다. 브라우저 설정을 확인하세요.');
        }
    }, []);

    function onClose()
    {
        const customWindow = window.open('about:blank', '_blank', '');

        if (customWindow)
        {
            window.opener='Self';	window.open('','_parent','');	window.close();

        }

    }


    return (
        <>
        <Button onClick={onClose} >클릭</Button>
        </>
    );
};

export default memo(PopupGate);